import { useApi } from "../api";
import { createAdminCrudApi } from "../createAdminCrudApi";
import {
  InsertTimberMaterialBody,
  SearchTimberMaterialsResponse,
  UpdateTimberMaterialBody,
} from "./types/timberMaterials";
import { SCREW_CONNECTOR_ADMIN_URL } from "./screwConnectorAdminUrl";
import { SCREW_CONNECTOR_URL } from "./screwConnectorUrl";

// Visibility and order go through the full update (no /visibility nor /order endpoints).
export const useScrewConnectorTimberMaterialsApi = () => {
  // The calculator reads the timber materials too.
  const crud = createAdminCrudApi<SearchTimberMaterialsResponse, InsertTimberMaterialBody, UpdateTimberMaterialBody>(
    useApi(),
    SCREW_CONNECTOR_ADMIN_URL,
    "timber_materials",
    [SCREW_CONNECTOR_URL],
  );

  return {
    useTimberMaterials: crud.useSearch,
    insertTimberMaterial: crud.insert,
    updateTimberMaterial: crud.update,
    deleteTimberMaterial: crud.remove,
  };
};

export default useScrewConnectorTimberMaterialsApi;
